export const aboutUsRoutes = {
  'route.about.index': '/about-us',
};
